import { Grid } from "@mui/material";
import React from "react";
import moment from "moment";
import QTDetailsTextFieldWithLabelSection from "../../../../common/QTDetailsTextFieldWithLabelSection";

// Accepts a Firestore Timestamp, a JS Date, or nothing. Returns AM/PM format.
const formatAreaDate = (value) => {
  if (!value) return "";
  let date;
  if (typeof value?.toDate === "function") date = value.toDate();
  else if (value?.seconds != null) date = moment.unix(value.seconds).toDate();
  else date = value;
  const m = moment(date);
  return m.isValid() ? m.format("MM/DD/YYYY hh:mm:ss A") : "";
};

const AreaDetailsDataFieldsSection = ({
  areaDetails,
  setAreaDetails,
  editEnabled,
}) => {
  return (
    <Grid container style={dataContainerStyles}>
      {/*left side column*/}
      <Grid item container direction={"column"} xs>
        <span
          style={{
            color: "#0A0A0AAB",
            fontSize: 14,
            fontWeight: 600,
            marginBottom: 20,
            fontFamily: "Avenir Book, sans-serif",
          }}
        >
          Area Details
        </span>
        {/*area name section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Area Name"}
          value={areaDetails.name}
          disabled={true}
          editEnabled={
            areaDetails?.name === "All"
              ? false
              : areaDetails?.name === "Nearby"
              ? false
              : editEnabled
          }
          onChange={(e) =>
            setAreaDetails({
              ...areaDetails,
              name: e.target.value,
            })
          }
        />
        {/*Status section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Area Status"}
          value={
            areaDetails.isActive === true || areaDetails.isActive === "Active"
              ? "Active"
              : "Inactive"
          }
          disabled={true}
          editEnabled={editEnabled}
          select={true}
          dropdownValues={["Active", "Inactive"]}
          onChange={(e) =>
            setAreaDetails({
              ...areaDetails,
              isActive: e.target.value,
            })
          }
        />
        {/*area position section*/}
        <QTDetailsTextFieldWithLabelSection
          label={"Area Position"}
          value={areaDetails.position}
          disabled={true}
          editEnabled={editEnabled}
          onChange={(e) =>
            setAreaDetails({
              ...areaDetails,
              position: e.target.value,
            })
          }
        />
      </Grid>
      {/*right side column (read-only dates)*/}
      <Grid item container direction={"column"} style={{ paddingTop: 40 }} xs>
        <QTDetailsTextFieldWithLabelSection
          label={"Date Created"}
          value={formatAreaDate(areaDetails?.createdAt)}
          disabled={true}
          editEnabled={false}
        />
        <QTDetailsTextFieldWithLabelSection
          label={"Date Last Modified"}
          value={formatAreaDate(areaDetails?.updatedAt)}
          disabled={true}
          editEnabled={false}
        />
      </Grid>
    </Grid>
  );
};

export default AreaDetailsDataFieldsSection;

const dataContainerStyles = {
  borderRadius: 12,
  boxShadow: " 0px 0px 30px 0px rgba(80, 85, 136, 0.15)",
  background: "var(--gray-99, #FCFCFC)",
  padding: "36px 15px",
  marginBottom: 30,
};
